<template>
  <section>
    <slot
      :toggleActive="toggleActive"
      :active="active"
    />
  </section>
</template>

<script>
export default {
  data() {
    return {
      active: '',
    }
  },
  methods: {
    toggleActive(t) {
      this.active = t
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/TheTimeline.vue